<app-navbar *ngIf="meta.viewMode === 'view'"></app-navbar>
<form #scaleForm="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Comment Details {{meta.title}}</h4>
    <a *ngIf="meta.viewMode === 'modal'" class="stewards-modal-external" [routerLink]="['/comments', comment.id]" target="_blank" title="Open in new tab">
      <fa name="external-link"></fa>
    </a>
    <button type="button" class="stewards-modal-close" *ngIf="meta.viewMode === 'modal'" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="meta.loading">
    <div class="row">
      <div class="col text-center">
        <fa name="circle-o-notch" size="2x" animation="spin"></fa>
      </div>
    </div>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="!meta.loading">
    <div class="row" *ngIf="comment.rpcComments && comment.rpcComments.length">
      <div class="col text-center">
        <span *ngFor="let rpcComment of comment.rpcComments; last as lastRPC">
          {{rpcComment.racePerformanceComment}}
          <br *ngIf="!lastRPC"/>
        </span>
      </div>
    </div>
    <div class="row" [ngClass]="{'pt-4': comment.rpcComments}" *ngIf="comment.comment">
      <div class="col text-center">
        <p>{{comment.comment}}</p>
      </div>
    </div>
    <hr>
    <div class="row pt-4">
      <div class="col text-right">
        <div class="d-flex flex-md-column">
          <small *ngIf="comment.published"><strong>This comment is published on the Stewards Report</strong></small>
          <small *ngIf="comment.createdByUserName"><i>Created by {{comment.createdByUserName}} @ {{comment.createdAt | date:'dd MMMM, yy h:mm a'}}</i></small>
          <small *ngIf="comment.isUpdated"><i>Updated by {{comment.updatedByUserName}} @ {{comment.updatedAt | date:'dd MMMM, yy h:mm a'}}</i></small>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-danger" (click)="delete()">Delete</button>
    <button type="button" class="btn btn-outline-dark stewards-modal-btn-close" *ngIf="meta.viewMode === 'modal'" (click)="cancel('cancel')">Close</button>
    <button type="button" class="btn btn-primary" [disabled]="!comment.comment && !comment.rpcComments" (click)="openEdit()">Edit</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
